import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'lynkd-pattern-pop-confirm',
  templateUrl: './pop-confirm.component.html',
  styleUrls: ['./pop-confirm.component.scss']
})
export class PopConfirmComponent {

  public constructor(
    private readonly _snackBarRef: MatSnackBarRef<PopConfirmComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: string
  ) {}

  public onSubmit(): void {
    this._snackBarRef.dismissWithAction();
  }

  public onCancel(): void {
    this._snackBarRef.dismiss();
  }
}
